<script setup lang="ts">
  import { cva } from 'class-variance-authority'
  import type { TColorVariant, TVariant } from '@/components/ui/label/types'

  const props = withDefaults(
    defineProps<{
      text: string
      colorVariant?: TColorVariant
      variant?: TVariant
    }>(),
    {
      colorVariant: 'green',
      variant: 'default'
    }
  )

  const labelClasses = computed(() =>
    cva('inline-block max-w-full truncate rounded-full px-2 py-0.5', {
      variants: {
        colorVariant: {
          green: 'bg-bt-green text-bt-blue-dark',
          orange: 'bg-dark-warning text-bt-blue-dark',
          red: 'bg-dark-error text-white',
          uiBlue: 'bg-bt-blue-ui text-white',
          darkBlue: 'bg-bt-blue-dark text-white',
          white: 'bg-white text-bt-blue-dark outline outline-1 outline-bt-blue-ui',
          greenGradient: 'bg-gradient-to-r from-bt-green to-[#F7FF9A] text-bt-blue-dark',
          darkBlueGradient: 'bg-gradient-to-r from-bt-blue-dark to-bt-blue-ui-light text-white'
        },
        variant: {
          default: 'text-subtitle-2',
          bestValue: 'text-subtitle-1'
        }
      }
    })({
      colorVariant: props.colorVariant || 'green',
      variant: props.variant || 'default'
    })
  )
</script>

<template>
  <span :class="labelClasses">{{ text }}</span>
</template>
